var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 586.63 564.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-11 {\n        fill: #5a545e;\n      }\n\n      .cls-12 {\n        fill: #929ab9;\n      }\n\n      .cls-13, .cls-14 {\n        fill: #84693b;\n      }\n\n      .cls-15 {\n        fill: #fff;\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-66 {\n        fill: #b1abab;\n      }\n\n      .cls-67, .cls-14 {\n        opacity: .1;\n      }\n\n      .cls-68 {\n        fill: #f4d2b6;\n      }\n\n      .cls-69 {\n        fill: #bebfdf;\n      }\n\n      .cls-70 {\n        fill: #333;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.53,
    y1: 425.11,
    x2: 516.61,
    y2: 425.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84693b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#99835d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#b8a88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#d1c7b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e5dfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f3f1ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fcfbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f6f4f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ebe7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dcd4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c8bca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#af9e81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#937c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84693b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 349.27,
    y1: 879.99,
    x2: 339.95,
    y2: 238.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84693b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#a99676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e6e1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 7609.86,
    y1: 173.5,
    x2: 7618.37,
    y2: 173.5,
    gradientTransform: "translate(7928.74) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#acb9d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c9cbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5d2eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 318.16,
    y1: 167.77,
    x2: 295.38,
    y2: 203.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f6f4f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ebe7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#dcd4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c8bca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#af9e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#937b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84693b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -10910.59,
    y1: 203.45,
    x2: -10900.63,
    y2: 186.2,
    gradientTransform: "translate(11219.48 -11.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7609.31,
    y1: 183.29,
    x2: 7619.79,
    y2: 183.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 323.46,
    y1: 148.88,
    x2: 302.9,
    y2: 196.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -10949.46,
    y1: 183.48,
    x2: -10938.71,
    y2: 164.85,
    gradientTransform: "translate(11256.99 8.22)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 216.08,
    y1: 315.98,
    x2: 365.25,
    y2: 399.58,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 181.36,
    y1: 377.94,
    x2: 330.53,
    y2: 461.54,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 241.9,
    y1: 315.02,
    x2: 427.96,
    y2: 429.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 200.52,
    y1: 382.5,
    x2: 386.58,
    y2: 496.59,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 336.39,
    y1: 196.98,
    x2: 384.7,
    y2: 196.98,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -346.1,
    y1: 550.68,
    x2: -275.34,
    y2: 628.46,
    gradientTransform: "translate(747.15 -262.92) rotate(14.71)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 309.68,
    y1: 183.89,
    x2: 360.73,
    y2: 183.89,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 340.44,
    y1: 203.25,
    x2: 355.7,
    y2: 203.25,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -10898.56,
    y1: 210.41,
    x2: -10887.8,
    y2: 191.78,
    gradientTransform: "translate(11237.52)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 364.81,
    y1: 188.68,
    x2: 328.14,
    y2: 223.18,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 303,
    y1: 140.78,
    x2: 359.81,
    y2: 215.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 347.3,
    y1: 205.67,
    x2: 357.77,
    y2: 205.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 307.04,
    y1: 137.7,
    x2: 363.85,
    y2: 212.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 311.91,
    y1: 133.99,
    x2: 368.73,
    y2: 208.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 311.05,
    y1: 134.65,
    x2: 367.87,
    y2: 209.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 342.29,
    y1: 157.08,
    x2: 321.73,
    y2: 204.31,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 318.09,
    y1: 218.14,
    x2: 344.69,
    y2: 218.14,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 315.11,
    y1: 223.54,
    x2: 324.44,
    y2: 223.54,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 268.04,
    y1: 353.3,
    x2: 283.38,
    y2: 402.39,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 206.46,
    y1: 339.84,
    x2: 322.1,
    y2: 339.84,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 372.26,
    y1: 392.06,
    x2: 351.2,
    y2: 228.49,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 723.95,
    y1: 270.26,
    x2: 702.89,
    y2: 106.68,
    gradientTransform: "translate(-414.8 245.83) rotate(-8.78)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 221.39,
    y1: 376.48,
    x2: 258.73,
    y2: 271.72,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 209.97,
    y1: 372.41,
    x2: 247.32,
    y2: 267.65,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 298.4,
    y1: 258.64,
    x2: 183.75,
    y2: 391.76,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 82.53,
    y1: 278.12,
    x2: 152.52,
    y2: 355.05,
    gradientTransform: "translate(192.72 -88.85) rotate(3.93)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 240.77,
    y1: 456.29,
    x2: 60.58,
    y2: 454.27,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 240.96,
    y1: 439.29,
    x2: 60.77,
    y2: 437.27,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 138.93,
    y1: 486.12,
    x2: 136.44,
    y2: 406.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 112.91,
    y1: 299.83,
    x2: 117.96,
    y2: 442.38,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 162.7,
    y1: 309.87,
    x2: 72.71,
    y2: 473.06,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 128.38,
    y1: 299.28,
    x2: 133.43,
    y2: 441.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 172.56,
    y1: 315.31,
    x2: 82.58,
    y2: 478.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 111.42,
    y1: 299.88,
    x2: 116.47,
    y2: 442.43,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 167.35,
    y1: 312.44,
    x2: 77.36,
    y2: 475.62,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 133.76,
    y1: 299.09,
    x2: 138.81,
    y2: 441.64,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 185.61,
    y1: 322.51,
    x2: 95.62,
    y2: 485.7,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 145.73,
    y1: 298.66,
    x2: 150.79,
    y2: 441.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 188.39,
    y1: 324.04,
    x2: 98.4,
    y2: 487.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 154.53,
    y1: 298.35,
    x2: 159.58,
    y2: 440.9,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 201.09,
    y1: 331.04,
    x2: 111.1,
    y2: 494.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 2685.46,
    y1: 183.02,
    x2: 2618.56,
    y2: 293.98,
    gradientTransform: "translate(3123.85) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 2900.76,
    y1: 359.68,
    x2: 2630.43,
    y2: 250.6,
    gradientTransform: "translate(3123.85) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 448.83,
    y1: 262.73,
    x2: 477.27,
    y2: 262.73,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 242.98,
    y1: 32.9,
    x2: 176.08,
    y2: 143.86,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 458.29,
    y1: 209.56,
    x2: 187.96,
    y2: 100.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 202.17,
    y1: 112.78,
    x2: 234.68,
    y2: 112.78,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 211.32,
    y1: 102.81,
    x2: 224.53,
    y2: 102.81,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 148.24,
    y1: 177.05,
    x2: 81.34,
    y2: 288.01,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 363.54,
    y1: 353.71,
    x2: 93.21,
    y2: 244.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 106.38,
    y1: 256.93,
    x2: 140.98,
    y2: 256.93,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M290.75,194.24s7.39-12.14,15.05-14.36c7.66-2.21-4.52,6.23-4.78,8.95s.39,3.24-.42,6.08-1.86,3.64-1.86,3.64l-8-4.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M426.09,442l-65.25-37.67c-10.77-6.22-28.18-6.22-38.88,0l-64.82,37.67c-5.39,3.13-8.04,7.24-7.98,11.35-11.08.47-21.91,3.14-30.36,8.02-18.8,10.85-18.7,28.5.21,39.42,18.91,10.92,49.48,10.98,68.28.12,5.99-3.46,10.05-7.6,12.21-12l23.02,13.29c10.77,6.22,28.18,6.22,38.88,0l64.82-37.67c10.7-6.22,10.64-16.31-.13-22.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M419.56,358.58c-.02.24-.04.49-.08.73-.04.2-.1.39-.15.59-.06.23-.12.46-.2.69-.07.19-.16.38-.24.56-.1.24-.21.48-.34.72-.09.17-.21.34-.31.52-.17.27-.35.54-.54.81-.19.26-.39.51-.61.76-.05.06-.1.12-.15.18-.3.33-.63.64-.98.96-.22.2-.47.39-.71.59-.21.17-.42.35-.65.51-.26.19-.55.37-.83.56-.29.19-.57.38-.88.57l-54.6,31.73c-.69.4-1.43.76-2.18,1.1-.22.1-.44.19-.66.28-.59.25-1.2.48-1.82.69-.22.08-.44.16-.67.23-.39.12-.79.23-1.19.34-.3.08-.6.17-.91.25-.42.1-.85.19-1.28.27-.29.06-.58.13-.87.18-.87.15-1.75.27-2.63.37-.27.03-.55.05-.82.07-.52.04-1.04.08-1.57.1-.33.01-.67.02-1,.03-.42,0-.85.01-1.27,0-.35,0-.71-.02-1.06-.03-.39-.02-.79-.04-1.18-.06-.36-.02-.71-.05-1.07-.09-.39-.04-.77-.08-1.16-.13-.35-.04-.69-.09-1.03-.15-.41-.06-.82-.14-1.23-.21-.32-.06-.64-.12-.96-.19-.49-.11-.96-.23-1.44-.35-.26-.07-.53-.14-.79-.21-.85-.25-1.68-.53-2.49-.84-.4-.15-.78-.32-1.16-.49-.2-.09-.41-.17-.6-.26-.58-.28-1.15-.57-1.7-.89l-54.96-31.73c-4.56-2.64-6.84-6.1-6.83-9.55l-.25,89.47c0,3.46,2.27,6.92,6.83,9.55l54.96,31.73c.55.32,1.11.61,1.7.89.2.09.4.17.6.26.34.15.68.31,1.04.45.04.02.09.03.13.04.8.31,1.63.59,2.48.84.07.02.13.05.2.07.19.06.4.09.6.15.48.13.95.25,1.44.35.13.03.25.07.38.09.19.04.39.06.58.1.41.08.81.15,1.23.21.17.03.33.06.49.09.18.03.36.04.55.06.38.05.77.09,1.15.13.18.02.37.05.55.06.17.01.35.02.52.03.39.03.78.05,1.17.06.2,0,.39.03.59.03.16,0,.31,0,.47,0,.42,0,.85,0,1.27,0,.21,0,.42,0,.63,0,.12,0,.25-.02.37-.02.52-.02,1.05-.06,1.57-.1.21-.02.42-.02.63-.04.06,0,.13-.02.19-.03.89-.09,1.77-.21,2.63-.37.04,0,.09-.01.13-.02.25-.05.5-.11.75-.16.43-.09.86-.17,1.28-.27.31-.07.61-.16.91-.24.4-.11.8-.22,1.19-.34.08-.03.17-.05.26-.07.14-.05.27-.11.41-.16.62-.21,1.23-.44,1.82-.69.22-.09.44-.18.66-.28.75-.34,1.49-.7,2.18-1.1l54.6-31.73c.09-.06.19-.11.28-.17.21-.13.4-.27.6-.4.28-.18.57-.36.83-.55.23-.17.44-.34.65-.51.24-.19.49-.39.71-.59.04-.04.1-.08.14-.12.3-.27.57-.56.83-.84.05-.06.1-.12.15-.18.15-.17.31-.35.45-.52.06-.08.1-.16.16-.24.2-.27.38-.54.54-.81.07-.11.16-.22.23-.34.03-.06.05-.12.08-.18.13-.24.23-.48.34-.72.06-.14.14-.28.2-.42.02-.05.02-.1.04-.14.08-.23.14-.46.2-.69.04-.16.1-.31.13-.47,0-.04,0-.08.01-.13.04-.24.06-.49.08-.73.01-.16.05-.32.05-.48,0-.07,0-.14,0-.2l.25-89.47c0,.23-.04.45-.06.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M412.78,348.35c9.07,5.24,9.12,13.73.11,18.97l-54.6,31.73c-9.01,5.24-23.68,5.24-32.75,0l-54.96-31.73c-9.07-5.24-9.12-13.73-.11-18.97l54.6-31.73c9.01-5.24,23.68-5.24,32.75,0l54.96,31.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.03,347.98c8.98,5.18,9.02,13.59.11,18.77l-54.03,31.4c-8.92,5.18-23.43,5.18-32.41,0l-54.38-31.4c-8.98-5.18-9.02-13.59-.11-18.77l54.03-31.4c8.92-5.18,23.43-5.18,32.41,0l54.38,31.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M313.85,175l-3.48-2.02c1.96-1.13,3.74-1.24,5.03-.49l3.48,2.02c-1.28-.75-3.06-.64-5.03.49h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.85,175l-3.48-2.02c-3.9,2.25-7.05,7.71-7.04,12.2,0,2.23.79,3.79,2.06,4.53l3.48,2.02c-1.27-.74-2.05-2.3-2.06-4.53-.01-4.48,3.14-9.94,7.04-12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.85,175c-3.9,2.25-7.05,7.71-7.04,12.2.01,4.48,3.19,6.29,7.09,4.04,3.9-2.25,7.05-7.71,7.04-12.2-.01-4.48-3.19-6.29-7.09-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.17,177.27c2.89-1.67,5.25-.33,5.26,2.99,0,3.32-2.33,7.37-5.22,9.04-2.89,1.67-5.25.33-5.26-2.99s2.33-7.37,5.22-9.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M312.68,169.21l4.61-2.68c-.03.1-.9,2.97-1.2,7.95-.74.26-2.98,1.39-4.62,2.7.3-4.99,1.18-7.87,1.2-7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M316.59,163.44l4.61-2.68c-1.89,1.1-3.28,3.05-3.9,5.77l-4.61,2.68c.63-2.72,2.01-4.67,3.9-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.27,159.42c-2.44-.7-4.75-.76-6.76-.16-3.27.98-5.58,3.69-6.5,7.64-.12.39-.86,3.01-1.21,7.47-.01.17-.14.15-.07.32,1.31.52,2.76,2.44,2.76,2.44.31-4.96,1.17-7.82,1.2-7.92,1.24-5.36,5.41-7.72,10.61-6.5,0-1.1,0-2.19-.03-3.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M316.61,175.78c4.21-2.43,7.64-.48,7.65,4.36.01,4.84-3.39,10.74-7.6,13.17-4.21,2.43-7.64.48-7.65-4.36-.01-4.84,3.39-10.74,7.6-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.95,174.03c-1.39-.81-3.31-.69-5.43.53-4.21,2.43-7.62,8.33-7.6,13.17,0,2.41.86,4.1,2.23,4.89l2.09,1.21c-1.37-.8-2.22-2.49-2.23-4.89-.01-4.84,3.39-10.74,7.6-13.17,2.12-1.22,4.04-1.34,5.43-.53l-2.09-1.21Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M235.61,466.15c-3.02,3.97-14.93,12.39-15.88,16.52-.95,4.13.16,5.88.16,5.88,0,0,1.24,3.97,11.9,1.59,10.65-2.38,16.54-7.44,26.54-14.68,10-7.24,13.81-11.05,13.81-11.05l-10.96-6.19-25.57,7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,438.84c-.16,9.53,0,15.56,0,15.56,0,0-19.06,20.65-20.8,23.82,0,0-2.7,4.76-.79,7.94,1.91,3.18,6.24,4.16,12.62,2.22,6.38-1.94,22.64-13.83,22.64-13.83l14.07-11.71v-9.24l-5.72-9.22-10.46-16.64-11.54,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.69,464.4c.95.32,3.97,3.02,4.29,5.88.32,2.86,1.11,8.26-.95,10.01-2.06,1.75-9.53,6.03-9.53,6.03,0,0-8.26,9.69-15.88,13.82-7.62,4.13-14.77,3.34-19.53,2.06-4.76-1.27-4.29-5.72-4.29-5.72l5.24-8.89,40.66-23.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.05,458.22c-.16,1.58-5.53,11.06-5.53,11.06,0,0-17.97,17.83-18.61,20.53-.64,2.7.16,7.78.16,7.78,0,0,3.65,5.24,15.72,3.02,12.07-2.22,18.26-17.15,22.71-19.69,4.45-2.54,9.53-10.8,9.53-10.8l-2.06-11.9h-21.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.66,304.96c-3.65,5.4-19.68,17.31-23.18,19.69-3.5,2.38-43.04,28.74-47.33,36.21-4.29,7.46-1.43,19.69-.48,24.62.95,4.92,26.05,6.03,32.72.95,6.67-5.08,47.17-29.24,55.43-39.08,8.26-9.84,5.08-36.52,5.08-36.52l-22.23-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M237.19,361.34c-5.72,7.15-12.71-1.45-10.88,16.51,1.83,17.96,9.77,78.94,9.77,78.94,0,0,14.61,3.34,21.12-.16,6.51-3.49,6.51-8.73,6.51-8.73,0,0-1.11-61.62-3.18-69.08-2.06-7.46-23.35-17.47-23.35-17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M311.84,319.88c-2.7,5.08-5.72,20.01-6.99,23.66-1.27,3.65-47.8,28.11-50.18,32.08-2.38,3.97-4.13,15.09-2.54,20.8,1.59,5.72,24.3,6.51,33.35,1.59,9.05-4.92,33.99-10.32,51.93-15.56s30.49-17.47,28.75-38.59c-1.75-21.12-8.73-34.14-8.73-34.14l-45.58,10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M251.52,391.35c1.08,16.99,2.67,65.9,3.31,72.42.64,6.51,21.76,7.78,23.82.95,2.06-6.83,8.58-37.8,8.58-56.38s-4.45-25.09-4.45-25.09l-31.26,8.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M342.36,166.92c4.19-9.89,28.73-5.58,27.68,11.63-1.05,17.22,5,39.78,14.66,41.18-5.82,7.21-19.54,16.63-38.73,10.59-19.19-6.05-3.61-63.39-3.61-63.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M266.82,258.58c2.14,2.85,5,4.56,7.45,3.66,1.17-.44,2.99-1.32,5.3-2.57,8.4-4.55,23.17-13.85,35.63-22.62,12.27-8.64,22.31-16.76,21.88-19.38-1.01-5.98-15.39-17.04-27.87-7.7-10.06,7.56-26.49,19.51-36.58,27.51,0,0,0,.01-.02.02-2.41,1.91-4.45,3.6-5.96,4.93-4.79,4.25-3.23,11.63.18,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M329.94,325.28c-11.91.95-30.8-3.36-31.22-10.81-2.48-43.81-5.58-39.73-6.7-47.35s-5.87-13.33,14.53-45.71c2.03-3.22,8.55-6.7,14.38-5.4s13.26-2.78,23.1,1.67c9.85,4.45,24.27,14.71,28.89,19.83,4.62,5.12.68,7.74.68,13.93s-7.94,29.38-11.12,37.48c-3.18,8.1-2.81,25.96-2.81,25.96,0,0-6.72,9.77-29.75,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M362.5,288.92c-3.18,8.1-2.81,25.96-2.81,25.96,0,0-6.72,9.77-29.75,10.4-11.91.95-30.8-3.36-31.22-10.81-1.78-31.43-3.88-38.21-5.34-42.35,5.27,8.2,11.11,10.62,15.53,11.75,4.95,1.27,25.45,11.96,34.34-1.59,8.89-13.55,16.66-18.03,16.66-18.03,0,0,4.35.52,10.36,1.85-2.56,8.53-5.95,18.15-7.78,22.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M348.07,221.11c4.3,5.12,7.04,10.03-5.41,23.01-12.46,12.98-32.05,27.58-32.05,27.58,0,0-7.07-24.67,3.01-45,5.98-12.05,12.23-7.39,16.28-7.07,4.05.32,18.17,1.47,18.17,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M319.3,208.77c1.06,2.65.62,9.32-.12,11.86-.74,2.54-3.29,8.21-2.55,12.77.74,4.55,3.47,14.17,24.05,2.6,8.68-4.88,9.37-9.41,8.3-11.83s-1.69-4.05-2.68-9.78c-.41-2.38-1.38-13.98.32-19.06s-2.22-12.92-2.22-12.92l-25.09,26.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M343.03,189.65c-.65,6.97,0,14.38-2.83,18.85-2.83,4.47-10.5,11.01-19.74,10.79-9.24-.22-10.22-3.16-10.22-3.16,0,0-2.61-14.06-2.94-20.92-.33-6.86,2.72-20.48,4.03-22.88,1.31-2.4,14.71-5.12,14.71-5.12,0,0,11.88,4.68,15.04,7.84,3.16,3.16,1.96,14.6,1.96,14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M320.59,171.67c2.07,2.29,13.84,11.66,16.13,14.71,2.29,3.05,2.07,10.79,2.07,10.79l2.98,7.39s2.67-10.2,4.19-11.28c1.53-1.09,3.28-.02,3.28-.02,0,0-3.6,10.15-3.55,12.86s0,4.68,0,4.68c0,0,9.48-6.96,10.83-10.54,5.53-14.6,4.96-17.58,1.96-26.74-3-9.15-14.48-13.72-14.48-13.72,0,0-6.43-3.7-12.86-2.61-6.43,1.09-18.47,8.39-20.46,11.66-1.99,3.27-.46,6.59-.46,6.59,0,0,1.85-3.1,2.72-3.32.87-.22,7.63-.44,7.63-.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M348.04,194.48c4.21-2.43,7.64-.48,7.65,4.36.01,4.84-3.39,10.74-7.6,13.17-4.21,2.43-7.64.48-7.65-4.36-.01-4.84,3.39-10.74,7.6-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M351.38,192.74c-1.39-.81-3.31-.69-5.43.53-4.21,2.43-7.62,8.33-7.6,13.17,0,2.41.86,4.1,2.23,4.89l2.09,1.21c-1.37-.8-2.22-2.49-2.23-4.89-.01-4.84,3.39-10.74,7.6-13.17,2.12-1.22,4.04-1.34,5.43-.53l-2.09-1.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M352.2,197.37l-3.48-2.02c1.96-1.13,3.74-1.24,5.03-.49l3.48,2.02c-1.28-.75-3.06-.64-5.03.49h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M352.2,197.37l-3.48-2.02c-3.9,2.25-7.05,7.71-7.04,12.2,0,2.23.79,3.79,2.06,4.53l3.48,2.02c-1.27-.74-2.05-2.3-2.06-4.53-.01-4.48,3.14-9.94,7.04-12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M352.2,197.37c-3.9,2.25-7.05,7.71-7.04,12.2.01,4.48,3.19,6.29,7.09,4.04,3.9-2.25,7.05-7.71,7.04-12.2-.01-4.48-3.19-6.29-7.09-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M352.52,199.65c2.89-1.67,5.25-.33,5.26,3,0,3.32-2.33,7.37-5.22,9.04-2.89,1.67-5.25.33-5.26-3s2.33-7.37,5.22-9.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M321.13,156.58c-.66.2-1.29.47-1.87.81l-4.61,2.68c.58-.34,1.21-.61,1.87-.81,3.23-.97,7.24-.21,11.29,2.12l4.61-2.68c-4.05-2.34-8.06-3.09-11.29-2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "327.8 161.38 332.42 158.7 338.17 162.02 333.55 164.7 327.8 161.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M333.55,164.7l4.61-2.68c2.27,1.31,4.49,3.08,6.59,5.26,3,3.11,5.62,6.93,7.57,11.06,1.93,4.09,3.13,8.33,3.47,12.24.23,2.69.63,7.63.53,6.93l-4.61,2.68c.1.7-.3-4.24-.53-6.93-.34-3.91-1.54-8.15-3.47-12.24-1.95-4.13-4.56-7.95-7.57-11.06-2.1-2.18-4.32-3.94-6.59-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M351.18,193.26c-.34-3.91-1.54-8.15-3.47-12.24-1.95-4.13-4.56-7.95-7.57-11.06-2.1-2.18-4.32-3.94-6.59-5.26l-5.75-3.32c-4.05-2.34-8.06-3.09-11.29-2.12-2.25.68-4.05,2.17-5.25,4.33,3.85-3.35,4.99-1.07,7.36-1.39,2.44-.34,6.14.6,9.18,2.35l5.75,3.32c1.92,1.11,3.8,2.61,5.58,4.45,5.16,5.34,8.73,12.89,9.32,19.7.08.91.18,2.08.27,3.34.19,2.4,3,4.83,3,4.83-.08-2.92-.3-4.24-.53-6.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M323.61,225.46c-.31-.02-.59-.03-.9-.05-1.77-.08-3.97-.18-4.63-1.55l1.33-.64c.27.57,2.44.67,3.36.72.33.02.63.03.87.05l6.48-.24c3.65-.32,7.83-3.44,10.59-7.95l2.66-4.98,1.3.7-2.68,5.02c-3.07,5.01-7.58,8.32-11.79,8.69l-6.61.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M324.43,225.05c.21-.9-2.59-2.43-4.21-3.08-1.62-.65-4.14-1.62-4.77.11-1.07,2.94.62,3.21,2.34,3.66,1.74.46,6.43.21,6.65-.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M208.73,336.35l66.42,37.87c3.33,1.92,7.24,1.34,9.91-.17l34.99-21.42c1.44-2.55,1.85-2.51,2.05-3.51v-.48l-113.86-19.64-.72.42c-.29.17-.52.39-.69.64,0,0,0,0,0,0-.2.54-.34,1.16-.34,1.53v1.81c-.02.87-.08,1.49,2.23,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M206.5,331.67c.1.59.44,1.15,1.03,1.5l38.54,22.25,29.93,17.28c1.84.75,4.55.78,7.48-.77l36.93-21.31c2.24-1.29,2.26-4.52.02-5.84h0l-51.59-29.69-11.25-6.68c-4.27-2.54-9.58-2.57-13.89-.08l-25.14,14.53-10.32,6.14-.72.42c-.29.17-.52.39-.69.64h0c-.33.49-.45,1.07-.34,1.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "215.97 332.55 239.91 318.73 301.32 354.2 277.38 368.02 215.97 332.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M345.19,318.04c2.08,1.66,4.42,2.57,6.61,2.29.04,0,.09-.01.13-.02,1.08-.14,2.12-.58,3.06-1.37.29-.61.57-1.22.85-1.83h0c.25-.53.48-1.04.72-1.55,24.05-52.33,19.06-70.81,18.61-73.77-.29-1.92-1.22-4.13-3.69-5.55-1.41-.83-3.32-1.39-5.89-1.5-7.11-.3-11.16,4.21-14.89,13.81-3.52,9.08-8.47,39.46-11.08,51.67-.15.7-.29,1.35-.43,1.92-1.41,6.06,1.75,12.55,6,15.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M340.4,306.78c-5.28.17-6.42,2.12-7.86,2.18-1.44.06-50.17,10.2-50.17,10.2,0,0-14.36,2.74-16.48,2.54-2.12-.19-11.78,3.87-13.57,5.75-1.8,1.88-5.99,4.94-5.7,6.83.29,1.88,2.43,2.2,2.43,2.2l4.14-3.37-5.86,7.82,2.57,1.05,3.2-1.3s1.15,2.42,2.94,1.49c1.78-.93,3.28-1.65,3.28-1.65l2.94,1.34,13.38-6.71,4.25-3.01s45.16-8.19,66.32-10.37c2.86-4.35,7.58-4.08,4.91-8.46-2.67-4.38-10.71-6.51-10.71-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M283.66,331.45l-2.18.39s.24,1.3,3.37,1.1c4.18-.26,44.61-2.39,66.86-10.08.04,0,.06-.02.1-.04.04,0,.09-.03.12-.04.77-.35,2.42-1.39,3.38-3.76h0c.19-.51.35-1.04.48-1.64.3-1.42.34-3.19-.03-5.37-.05-.34-.13-.65-.22-.96-1.98-7.09-11.6-7.04-18.82-6.25-1.15.13-2.25.27-3.24.41-7.46,1.04-49.59,12.64-51.59,12.85-2,.22-2.95,1.73-2.95,1.73,0,0,2.26-.09,3.8,3.64,1.15,2.78,1.1,5.85.99,7.24-.03.49-.07.78-.07.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "210 330.17 237.12 314.5 241.65 316.93 214.36 332.69 210 330.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M274.26,374.34l-65.42-39.89c-1.61-.93-.74-2.45-2.02-4.62l-9.47-42.53c-1.61-4.51,1.84-5.99,4.56-5.08l67.9,38.14c1.77.6,4.75,4.19,4.71,6.05l5.18,47.13c-1.32,2.03-2.37,1.54-5.43.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M201.9,282.21l67.9,38.14c.71.24,1.62.97,2.44,1.87l-28.6,21.01c-2.93,1.56-5.64,1.53-7.48.77l-29.93-17.27-1.16-.67-7.74-38.77c-1.61-4.51,1.84-5.99,4.56-5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M197.21,288.16l3.49,20.57,4.32,22.19c1.29,2.18.42,3.69,2.03,4.63l8.3,4.81,24.8,14.38,14.31,8.3,19.54,11.33c1.9.99,2.54,1.47,3.86.66.06-.04.12-.08.19-.12l-5.33-47.4c.05-1.87-2.94-5.45-4.71-6.05l-15.44-8.67-24.4-13.71-14.1-7.91-13.97-7.85c-2.72-.92-4.51.34-2.9,4.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M235.05,323.64c2.37.84,4.67,3.53,5.34,6.37.66,2.78-.65,4.22-3.03,3.38-2.35-.83-4.67-3.55-5.33-6.33-.67-2.84.66-4.26,3.02-3.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M292.24,193.05s-2.54,1.24-6.11,4.81-29.07,47.96-20.24,59.46c8.83,11.5,14.14-4.52,17.47-11.3,3.33-6.79,16.81-41.9,16.18-45.04s-3.48-8.74-7.3-7.93Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M156.96,444.59c11.21,6.47,11.25,16.95.15,23.39-11.11,6.47-29.15,6.47-40.36-.01-11.18-6.45-11.23-16.91-.13-23.36,11.1-6.45,29.18-6.47,40.34-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M152.12,446.25c8.51,4.91,8.52,12.86.1,17.75-8.43,4.9-22.13,4.9-30.63-.01-8.49-4.9-8.53-12.83-.09-17.73,8.42-4.89,22.14-4.91,30.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "108.33 420.93 115.2 456.3 158.46 456.3 165.4 420.02 108.33 420.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M156.96,408.33c11.21,6.47,11.25,16.95.15,23.4-11.11,6.45-29.14,6.45-40.35-.02-11.19-6.46-11.24-16.9-.14-23.35,11.1-6.45,29.18-6.46,40.34-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M150.77,411.48c8.2,4.73,8.2,12.37.08,17.1-8.11,4.71-21.29,4.71-29.48-.02-8.17-4.73-8.22-12.35-.11-17.08,8.12-4.7,21.34-4.71,29.51,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M115.56,422.21s-21.04-26.61-.36-74.47c0,0,18.18,22.92,7.76,81.66,0,0-4.05-1.51-7.4-7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M115.45,348.08c.4,18.43,1.44,50.42,3.97,78.94,1.97,1.79,3.54,2.38,3.54,2.38,9.7-54.78-5.41-78.38-7.51-81.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M125.92,418.95s-16.87-29.45,10.72-73.7c0,0,14.57,25.37-4.48,81.92,0,0-3.77-2.1-6.24-8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M136.64,345.25c-2.34,18.29-7.54,50.04-9.26,78.62,1.7,2.07,3.15,2.89,3.15,2.89,20.69-49.39,7.74-78.3,6.11-81.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M126.99,430.57s-25.24-8.91-31.53-49.56c0,0,21.76,7.65,39.51,51.26,0,0-3.34.68-7.97-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M95.76,381.13c8.01,12.15,22.13,33.07,35.82,51.04,2.08.36,3.37.11,3.37.11-16.54-40.65-36.55-50.05-39.2-51.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M138.19,426.65s-13.51-15.43-2.45-44.95c0,0,11.66,13.29,7.15,49.07,0,0-2.5-.78-4.7-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M135.9,381.89c.79,11.12,2.37,30.42,4.75,47.55,1.26,1.02,2.23,1.33,2.23,1.33,4.2-33.35-5.63-47.16-6.99-48.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M144.19,416.75s-12.91-23.45,9.39-58c0,0,11.17,20.21-4.58,64.55,0,0-2.94-1.7-4.81-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M153.73,359.05c-2.08,14.39-5.46,39.42-7.17,61.93,1.31,1.65,2.43,2.31,2.43,2.31,14.67-41.35,5.99-61.67,4.74-64.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M147.5,421.12s-3.06-19.76,21.41-38.28c0,0,2.69,17.01-19.71,44.11,0,0-1.63-1.96-1.71-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M168.96,383.08c-5.17,9.56-13.9,26.27-20.87,41.63.49,1.5,1.12,2.25,1.12,2.25,20.86-25.26,19.96-41.75,19.75-43.87Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M501.29,250.19c0-.14-.01-.27-.02-.41,0-.06-.01-.13-.01-.19,0-.03,0-.05,0-.08,0-.05,0-.1-.01-.14-.01-.14-.03-.28-.05-.41-.02-.14-.04-.28-.06-.42,0,0,0,0,0-.01,0,0,0-.01,0-.02-.02-.13-.04-.27-.07-.4-.03-.15-.06-.29-.09-.44-.01-.05-.02-.1-.04-.16,0-.03-.01-.06-.02-.09-.02-.06-.03-.13-.05-.19-.04-.15-.08-.3-.12-.45-.03-.11-.06-.22-.1-.33,0-.02-.01-.04-.02-.06,0-.02-.01-.04-.02-.06-.04-.15-.09-.29-.14-.44-.05-.14-.1-.29-.15-.43,0-.03-.02-.05-.03-.08,0-.02-.02-.04-.02-.06-.03-.09-.07-.18-.1-.27-.05-.14-.11-.27-.17-.41-.04-.1-.08-.2-.13-.29,0-.02-.01-.03-.02-.05,0-.02-.02-.04-.02-.06-.06-.14-.12-.27-.19-.41-.07-.15-.14-.3-.22-.45-.01-.02-.02-.04-.03-.07-.01-.03-.03-.06-.04-.09-.06-.12-.12-.24-.18-.35-.08-.15-.16-.29-.24-.43-.04-.07-.08-.15-.12-.22-.02-.03-.03-.06-.05-.09-.07-.13-.16-.25-.23-.37-.11-.18-.22-.36-.34-.54-.02-.03-.04-.06-.05-.09-.17-.26-.35-.51-.53-.76,0,0,0,0,0,0,0,0,0,0,0,0-.12-.17-.25-.33-.38-.49-.1-.13-.21-.26-.31-.39,0,0,0,0,0,0,0,0,0,0,0,0-.11-.13-.22-.26-.33-.38-.11-.12-.22-.24-.33-.36-.02-.02-.04-.04-.05-.06-.02-.02-.04-.04-.06-.06-.08-.08-.15-.16-.23-.24-.12-.12-.24-.24-.36-.35-.04-.04-.07-.07-.11-.1-.03-.03-.06-.05-.08-.08-.06-.05-.12-.11-.18-.16-.12-.11-.25-.22-.38-.33-.05-.05-.11-.09-.17-.14-.03-.02-.06-.05-.09-.07-.04-.03-.08-.07-.12-.1-.12-.1-.25-.19-.37-.28-.09-.07-.18-.13-.27-.19-.02-.01-.03-.02-.05-.04-.02-.01-.03-.02-.05-.03-.12-.08-.24-.16-.36-.24-.12-.08-.24-.15-.36-.22-.03-.02-.06-.03-.08-.05l-50.03-28.88c-.09-.05-.18-.1-.27-.15-.12-.06-.23-.12-.35-.18-.07-.04-.15-.07-.22-.1-.02,0-.04-.02-.05-.03-.02,0-.04-.02-.07-.03-.11-.05-.23-.1-.34-.14-.11-.05-.23-.09-.34-.13-.02,0-.04-.01-.06-.02-.02,0-.03-.01-.05-.02-.08-.03-.15-.05-.23-.07-.12-.04-.23-.07-.35-.1-.06-.01-.11-.02-.17-.04-.02,0-.05-.01-.07-.02-.04,0-.07-.02-.11-.02-.12-.02-.25-.04-.37-.06-.08-.01-.15-.02-.22-.02-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.13,0-.27-.01-.4-.01-.06,0-.11,0-.17,0-.04,0-.09,0-.13,0-.05,0-.09,0-.14,0-.17.02-.33.04-.49.07,0,0,0,0,0,0-.03,0-.07.02-.1.03-.16.04-.33.08-.48.13-.01,0-.02.01-.04.02-.22.08-.44.18-.64.3,0,0,0,0,0,0l-4.7,2.73c.2-.12.42-.22.65-.3.17-.06.34-.11.51-.15.04,0,.07-.02.1-.03.2-.04.42-.07.63-.08.04,0,.09,0,.13,0,.21,0,.42,0,.64.01.03,0,.05,0,.08,0,.23.02.46.06.7.11.02,0,.05.01.07.02.24.05.49.12.74.21.02,0,.03.01.05.02.26.09.53.2.8.32.02,0,.04.02.05.03.28.13.55.27.84.43l50.03,28.88c.29.16.57.34.84.54.02.01.03.02.05.04.26.18.51.37.76.58.03.02.06.05.09.07.24.2.48.41.72.63.03.03.06.05.08.08.24.22.47.46.7.7.02.02.04.04.06.06.24.26.48.53.71.81,0,0,0,0,0,.01.24.28.47.58.69.88t0,0s0,0,0,0c.2.27.4.56.58.84.12.18.23.36.34.54.09.15.19.3.28.45.04.07.08.15.13.22.15.26.29.52.42.78.01.03.03.06.05.09.16.32.32.65.46.98,0,.02.01.04.02.05.14.32.27.65.39.97,0,.02.02.04.02.06.12.33.24.67.34,1,0,.02.01.04.02.06.1.32.18.65.26.97,0,.03.01.06.02.09.08.33.14.66.19.99,0,0,0,.01,0,.02.05.33.09.66.12.99,0,.03,0,.05,0,.08.03.33.04.65.04.98l-.16,57.48c0,.32-.02.63-.04.93,0,.03,0,.05,0,.08-.03.27-.07.53-.11.79,0,.03-.01.07-.02.1-.05.24-.11.48-.18.7-.01.04-.03.08-.04.12-.07.21-.15.41-.24.6,0,.02-.02.05-.03.07-.1.22-.22.42-.34.61-.02.03-.04.05-.05.07-.1.15-.21.3-.33.43-.04.05-.09.1-.13.14-.1.11-.21.21-.32.31-.05.04-.09.08-.14.12-.16.12-.32.24-.49.34l4.7-2.73c.17-.1.33-.22.49-.34.05-.04.09-.08.14-.12.11-.1.22-.2.32-.31.04-.05.09-.09.13-.14.12-.14.23-.28.33-.43.02-.02.04-.05.05-.07,0,0,0-.01.01-.02.12-.18.22-.37.32-.58,0,0,0-.01,0-.02.01-.02.02-.04.03-.07.06-.13.11-.26.17-.39.03-.07.05-.14.07-.21.01-.04.03-.08.04-.12.01-.04.03-.07.04-.11.04-.14.08-.28.11-.43.01-.05.02-.11.03-.16,0-.03.01-.07.02-.1,0-.05.02-.1.03-.15.02-.13.04-.27.06-.4,0-.08.02-.15.02-.23,0-.03,0-.05,0-.08,0-.03,0-.06,0-.1.01-.13.02-.26.02-.4,0-.13,0-.27,0-.41,0,0,0-.02,0-.02l.16-57.48c0-.13,0-.25,0-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M488.18,238.72c4.66,2.69,8.43,9.22,8.42,14.58l-.16,57.48c-.02,5.36-3.81,7.52-8.47,4.83l-50.03-28.88c-4.66-2.69-8.43-9.22-8.42-14.58l.16-57.48c.02-5.36,3.81-7.52,8.47-4.83l50.03,28.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M429.52,272.29c-.02,5.34,3.74,11.85,8.39,14.53l49.87,28.79c4.65,2.68,8.43.53,8.44-4.81l.16-57.3c.02-5.34-3.74-11.85-8.39-14.53l-49.87-28.79c-4.65-2.68-8.43-.53-8.44,4.81l-.04,13.1-.07,22.96-.06,21.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M453.36,241.01c.43.25.85.68,1.18,1.24l5.53,9.58c.65,1.13.65,2.34,0,2.72l-2.21,1.26c.06.2,1.13,3.91,3.68,8.33,2.55,4.42,5.02,6.85,5.15,6.97l2.21-1.26c.33-.19.76-.13,1.18.12s.85.68,1.18,1.24l5.53,9.58c.65,1.13.65,2.34,0,2.72l-1.56.89c-.09.05-1.74.99-5.08-.94-3.11-1.8-7.61-6.12-13.39-16.13-12.61-21.85-6.45-25.36-6.13-25.54l1.56-.89c.33-.19.76-.13,1.18.12Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M180.09,100.06c0-.14.01-.27.02-.41,0-.06.01-.13.01-.19,0-.03,0-.05,0-.08,0-.05,0-.1.01-.14.01-.14.03-.28.05-.41.02-.14.04-.28.06-.42,0,0,0,0,0-.01,0,0,0-.01,0-.02.02-.13.04-.27.07-.4.03-.15.06-.29.09-.44.01-.05.02-.1.04-.16,0-.03.01-.06.02-.09.02-.06.03-.13.05-.19.04-.15.08-.3.12-.45.03-.11.06-.22.1-.33,0-.02.01-.04.02-.06,0-.02.01-.04.02-.06.04-.15.09-.29.14-.44.05-.14.1-.29.15-.43,0-.03.02-.05.03-.08,0-.02.02-.04.02-.06.03-.09.07-.18.1-.27.05-.14.11-.27.17-.41.04-.1.08-.2.13-.29,0-.02.01-.03.02-.05,0-.02.02-.04.02-.06.06-.14.12-.27.19-.41.07-.15.14-.3.22-.45.01-.02.02-.04.03-.07.01-.03.03-.06.04-.09.06-.12.12-.24.18-.35.08-.15.16-.29.24-.43.04-.07.08-.15.12-.22.02-.03.03-.06.05-.09.07-.13.16-.25.23-.37.11-.18.22-.36.34-.54.02-.03.04-.06.05-.09.17-.26.35-.51.53-.76,0,0,0,0,0,0,0,0,0,0,0,0,.12-.17.25-.33.38-.49.1-.13.21-.26.31-.39,0,0,0,0,0,0,0,0,0,0,0,0,.11-.13.22-.26.33-.38.11-.12.22-.24.33-.36.02-.02.04-.04.05-.06.02-.02.04-.04.06-.06.08-.08.15-.16.23-.24.12-.12.24-.24.36-.35.04-.04.07-.07.11-.1.03-.03.06-.05.08-.08.06-.05.12-.11.18-.16.12-.11.25-.22.38-.33.05-.05.11-.09.17-.14.03-.02.06-.05.09-.07.04-.03.08-.07.12-.1.12-.1.25-.19.37-.28.09-.07.18-.13.27-.19.02-.01.03-.02.05-.04.02-.01.03-.02.05-.03.12-.08.24-.16.36-.24.12-.08.24-.15.36-.22.03-.02.06-.03.08-.05l50.03-28.88c.09-.05.18-.1.27-.15.12-.06.23-.12.35-.18.07-.04.15-.07.22-.1.02,0,.04-.02.05-.03.02,0,.04-.02.07-.03.11-.05.23-.1.34-.14.11-.05.23-.09.34-.13.02,0,.04-.01.06-.02.02,0,.03-.01.05-.02.08-.03.15-.05.23-.07.12-.04.23-.07.35-.1.06-.01.11-.02.17-.04.02,0,.05-.01.07-.02.04,0,.07-.02.11-.02.12-.02.25-.04.37-.06.08-.01.15-.02.22-.02.03,0,.05,0,.08,0,.02,0,.05,0,.07,0,.13,0,.27-.01.4-.01.06,0,.11,0,.17,0,.04,0,.09,0,.13,0,.05,0,.09,0,.14,0,.17.02.33.04.49.07,0,0,0,0,0,0,.03,0,.07.02.1.03.16.04.33.08.48.13.01,0,.02.01.04.02.22.08.44.18.64.3,0,0,0,0,0,0l4.7,2.73c-.2-.12-.42-.22-.65-.3-.17-.06-.34-.11-.51-.15-.04,0-.07-.02-.1-.03-.2-.04-.42-.07-.63-.08-.04,0-.09,0-.13,0-.21,0-.42,0-.64.01-.03,0-.05,0-.08,0-.23.02-.46.06-.7.11-.02,0-.05.01-.07.02-.24.05-.49.12-.74.21-.02,0-.03.01-.05.02-.26.09-.53.2-.8.32-.02,0-.04.02-.05.03-.28.13-.55.27-.84.43l-50.03,28.88c-.29.16-.57.34-.84.54-.02.01-.03.02-.05.04-.26.18-.51.37-.76.58-.03.02-.06.05-.09.07-.24.2-.48.41-.72.63-.03.03-.06.05-.08.08-.24.22-.47.46-.7.7-.02.02-.04.04-.06.06-.24.26-.48.53-.71.81,0,0,0,0,0,.01-.24.28-.47.58-.69.88t0,0s0,0,0,0c-.2.27-.4.56-.58.84-.12.18-.23.36-.34.54-.09.15-.19.3-.28.45-.04.07-.08.15-.13.22-.15.26-.29.52-.42.78-.01.03-.03.06-.05.09-.16.32-.32.65-.46.98,0,.02-.01.04-.02.05-.14.32-.27.65-.39.97,0,.02-.02.04-.02.06-.12.33-.24.67-.34,1,0,.02-.01.04-.02.06-.1.32-.18.65-.26.97,0,.03-.01.06-.02.09-.08.33-.14.66-.19.99,0,0,0,.01,0,.02-.05.33-.09.66-.12.99,0,.03,0,.05,0,.08-.03.33-.04.65-.04.98l.16,57.48c0,.32.02.63.04.93,0,.03,0,.05,0,.08.03.27.07.53.11.79,0,.03.01.07.02.1.05.24.11.48.18.7.01.04.03.08.04.12.07.21.15.41.24.6,0,.02.02.05.03.07.1.22.22.42.34.61.02.03.04.05.05.07.1.15.21.3.33.43.04.05.09.1.13.14.1.11.21.21.32.31.05.04.09.08.14.12.16.12.32.24.49.34l-4.7-2.73c-.17-.1-.33-.22-.49-.34-.05-.04-.09-.08-.14-.12-.11-.1-.22-.2-.32-.31-.04-.05-.09-.09-.13-.14-.12-.14-.23-.28-.33-.43-.02-.02-.04-.05-.05-.07,0,0,0-.01-.01-.02-.12-.18-.22-.37-.32-.58,0,0,0-.01,0-.02-.01-.02-.02-.04-.03-.07-.06-.13-.11-.26-.17-.39-.03-.07-.05-.14-.07-.21-.01-.04-.03-.08-.04-.12-.01-.04-.03-.07-.04-.11-.04-.14-.08-.28-.11-.43-.01-.05-.02-.11-.03-.16,0-.03-.01-.07-.02-.1,0-.05-.02-.1-.03-.15-.02-.13-.04-.27-.06-.4,0-.08-.02-.15-.02-.23,0-.03,0-.05,0-.08,0-.03,0-.06,0-.1-.01-.13-.02-.26-.02-.4,0-.13,0-.27,0-.41,0,0,0-.02,0-.02l-.16-57.48c0-.13,0-.25,0-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M193.2,88.6c-4.66,2.69-8.43,9.22-8.42,14.58l.16,57.48c.02,5.36,3.81,7.52,8.47,4.83l50.03-28.88c4.66-2.69,8.43-9.22,8.42-14.58l-.16-57.48c-.02-5.36-3.81-7.52-8.47-4.83l-50.03,28.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M251.86,122.17c.02,5.34-3.74,11.85-8.39,14.53l-49.87,28.79c-4.65,2.68-8.43.53-8.44-4.81l-.16-57.3c-.02-5.34,3.74-11.85,8.39-14.53l49.87-28.79c4.65-2.68,8.43-.53,8.44,4.81l.04,13.1.07,22.96.06,21.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M231.66,93.25c1.64-.95,2.97-.19,2.98,1.7l.05,16.92c0,1.88-1.32,4.18-2.96,5.12l-12.79,7.38-.95.55-12.79,7.39c-1.64.95-2.97.18-2.97-1.7l-.05-16.92c0-1.88,1.31-4.17,2.95-5.12l1.53-.88c.79-.45,1.54-.53,2.1-.21l8.31,2.81c.4.13.88.04,1.35-.24s.96-.73,1.35-1.32l8.27-12.39c.56-.96,1.31-1.76,2.1-2.21l1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M223.87,97.77c.63-.36.9.39.41,1.12l-5.33,7.85c-.3.43-.65.77-1.01.98s-.71.28-1.01.19l-5.36-1.68c-.5-.16-.23-1.23.4-1.59l11.89-6.86Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M85.34,244.22c0-.14.01-.27.02-.41,0-.06.01-.13.01-.19,0-.03,0-.05,0-.08,0-.05,0-.1.01-.14.01-.14.03-.28.05-.41.02-.14.04-.28.06-.42,0,0,0,0,0-.01,0,0,0-.01,0-.02.02-.13.04-.27.07-.4.03-.15.06-.29.09-.44.01-.05.02-.1.04-.16,0-.03.01-.06.02-.09.02-.06.03-.13.05-.19.04-.15.08-.3.12-.45.03-.11.06-.22.1-.33,0-.02.01-.04.02-.06,0-.02.01-.04.02-.06.04-.15.09-.29.14-.44.05-.14.1-.29.15-.43,0-.03.02-.05.03-.08,0-.02.02-.04.02-.06.03-.09.07-.18.1-.27.05-.14.11-.27.17-.41.04-.1.08-.2.13-.29,0-.02.01-.03.02-.05,0-.02.02-.04.02-.06.06-.14.12-.27.19-.41.07-.15.14-.3.22-.45.01-.02.02-.04.03-.07.01-.03.03-.06.04-.09.06-.12.12-.24.18-.35.08-.15.16-.29.24-.43.04-.07.08-.15.12-.22.02-.03.03-.06.05-.09.07-.13.16-.25.23-.37.11-.18.22-.36.34-.54.02-.03.04-.06.05-.09.17-.26.35-.51.53-.76,0,0,0,0,0,0,0,0,0,0,0,0,.12-.17.25-.33.38-.49.1-.13.21-.26.31-.39,0,0,0,0,0,0,0,0,0,0,0,0,.11-.13.22-.26.33-.38.11-.12.22-.24.33-.36.02-.02.04-.04.05-.06.02-.02.04-.04.06-.06.08-.08.15-.16.23-.24.12-.12.24-.24.36-.35.04-.04.07-.07.11-.1.03-.03.06-.05.08-.08.06-.05.12-.11.18-.16.12-.11.25-.22.38-.33.05-.05.11-.09.17-.14.03-.02.06-.05.09-.07.04-.03.08-.07.12-.1.12-.1.25-.19.37-.28.09-.07.18-.13.27-.19.02-.01.03-.02.05-.04.02-.01.03-.02.05-.03.12-.08.24-.16.36-.24.12-.08.24-.15.36-.22.03-.02.06-.03.08-.05l50.03-28.88c.09-.05.18-.1.27-.15.12-.06.23-.12.35-.18.07-.04.15-.07.22-.1.02,0,.04-.02.05-.03.02,0,.04-.02.07-.03.11-.05.23-.1.34-.14.11-.05.23-.09.34-.13.02,0,.04-.01.06-.02.02,0,.03-.01.05-.02.08-.03.15-.05.23-.07.12-.04.23-.07.35-.1.06-.01.11-.02.17-.04.02,0,.05-.01.07-.02.04,0,.07-.02.11-.02.12-.02.25-.04.37-.06.08-.01.15-.02.22-.02.03,0,.05,0,.08,0,.02,0,.05,0,.07,0,.13,0,.27-.01.4-.01.06,0,.11,0,.17,0,.04,0,.09,0,.13,0,.05,0,.09,0,.14,0,.17.02.33.04.49.07,0,0,0,0,0,0,.03,0,.07.02.1.03.16.04.33.08.48.13.01,0,.02.01.04.02.22.08.44.18.64.3,0,0,0,0,0,0l4.7,2.73c-.2-.12-.42-.22-.65-.3-.17-.06-.34-.11-.51-.15-.04,0-.07-.02-.1-.03-.2-.04-.42-.07-.63-.08-.04,0-.09,0-.13,0-.21,0-.42,0-.64.01-.03,0-.05,0-.08,0-.23.02-.46.06-.7.11-.02,0-.05.01-.07.02-.24.05-.49.12-.74.21-.02,0-.03.01-.05.02-.26.09-.53.2-.8.32-.02,0-.04.02-.05.03-.28.13-.55.27-.84.43l-50.03,28.88c-.29.16-.57.34-.84.54-.02.01-.03.02-.05.04-.26.18-.51.37-.76.58-.03.02-.06.05-.09.07-.24.2-.48.41-.72.63-.03.03-.06.05-.08.08-.24.22-.47.46-.7.7-.02.02-.04.04-.06.06-.24.26-.48.53-.71.81,0,0,0,0,0,.01-.24.28-.47.58-.69.88t0,0s0,0,0,0c-.2.27-.4.56-.58.84-.12.18-.23.36-.34.54-.09.15-.19.3-.28.45-.04.07-.08.15-.13.22-.15.26-.29.52-.42.78-.01.03-.03.06-.05.09-.16.32-.32.65-.46.98,0,.02-.01.04-.02.05-.14.32-.27.65-.39.97,0,.02-.02.04-.02.06-.12.33-.24.67-.34,1,0,.02-.01.04-.02.06-.1.32-.18.65-.26.97,0,.03-.01.06-.02.09-.08.33-.14.66-.19.99,0,0,0,.01,0,.02-.05.33-.09.66-.12.99,0,.03,0,.05,0,.08-.03.33-.04.65-.04.98l.16,57.48c0,.32.02.63.04.93,0,.03,0,.05,0,.08.03.27.07.53.11.79,0,.03.01.07.02.1.05.24.11.48.18.7.01.04.03.08.04.12.07.21.15.41.24.6,0,.02.02.05.03.07.1.22.22.42.34.61.02.03.04.05.05.07.1.15.21.3.33.43.04.05.09.1.13.14.1.11.21.21.32.31.05.04.09.08.14.12.16.12.32.24.49.34l-4.7-2.73c-.17-.1-.33-.22-.49-.34-.05-.04-.09-.08-.14-.12-.11-.1-.22-.2-.32-.31-.04-.05-.09-.09-.13-.14-.12-.14-.23-.28-.33-.43-.02-.02-.04-.05-.05-.07,0,0,0-.01-.01-.02-.12-.18-.22-.37-.32-.58,0,0,0-.01,0-.02-.01-.02-.02-.04-.03-.07-.06-.13-.11-.26-.17-.39-.03-.07-.05-.14-.07-.21-.01-.04-.03-.08-.04-.12-.01-.04-.03-.07-.04-.11-.04-.14-.08-.28-.11-.43-.01-.05-.02-.11-.03-.16,0-.03-.01-.07-.02-.1,0-.05-.02-.1-.03-.15-.02-.13-.04-.27-.06-.4,0-.08-.02-.15-.02-.23,0-.03,0-.05,0-.08,0-.03,0-.06,0-.1-.01-.13-.02-.26-.02-.4,0-.13,0-.27,0-.41,0,0,0-.02,0-.02l-.16-57.48c0-.13,0-.25,0-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.46,232.76c-4.66,2.69-8.43,9.22-8.42,14.58l.16,57.48c.02,5.36,3.81,7.52,8.47,4.83l50.03-28.88c4.66-2.69,8.43-9.22,8.42-14.58l-.16-57.48c-.02-5.36-3.81-7.52-8.47-4.83l-50.03,28.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M157.12,266.32c.02,5.34-3.74,11.85-8.39,14.53l-49.87,28.79c-4.65,2.68-8.43.53-8.44-4.81l-.16-57.3c-.02-5.34,3.74-11.85,8.39-14.53l49.87-28.79c4.65-2.68,8.43-.53,8.44,4.81l.04,13.1.07,22.96.06,21.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M129.02,240.13c6.58-3.8,11.94-.75,11.96,6.82.02,6.2-3.56,13.51-8.48,18.04l.02,6.59-5.25-3-8.94,5.16c-6.58,3.8-11.93.75-11.95-6.81s5.29-16.78,11.88-20.58l10.76-6.21ZM123.69,259.95c1.45-.84,2.63-2.87,2.62-4.53,0-1.66-1.19-2.34-2.64-1.5s-2.62,2.87-2.61,4.54,1.18,2.34,2.63,1.5M116.54,264.08c1.46-.84,2.63-2.87,2.62-4.53,0-1.66-1.18-2.34-2.64-1.5-1.45.84-2.62,2.87-2.61,4.54,0,1.66,1.18,2.34,2.63,1.5M130.84,255.82c1.45-.84,2.62-2.86,2.61-4.53,0-1.66-1.18-2.34-2.63-1.51s-2.62,2.87-2.61,4.54c0,1.66,1.18,2.34,2.63,1.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIllustration);
export default __webpack_public_path__ + "static/media/contact_illustration.4dfbdfd3bf6045d7fa340fe956099be2.svg";
export { ForwardRef as ReactComponent };